// extracted by mini-css-extract-plugin
export var backdrop = "Search-module--backdrop--dce55";
export var description = "Search-module--description--80405";
export var filter = "Search-module--filter--13a75";
export var input = "Search-module--input--3cbe0";
export var result = "Search-module--result--cf188";
export var results = "Search-module--results--8cb3d";
export var search = "Search-module--search--fcbd5";
export var type = "Search-module--type--6fe94";
export var wrapper = "Search-module--wrapper--6aed3";